import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchData = createAsyncThunk(
  'favour/fetchData',
  async ({ ids }, _) => {
    const url = '/favorites/data';
    const body = new FormData();
    body.append('ids', JSON.stringify(ids));
    const resp = await fetch(url, {
      method: 'POST',
      body,
    });

    if (!resp.ok) {
      throw new Error(`request ${url} failed, response status: ${resp.status}`);
    }
    const data = await resp.json();
    const { prods, categories } = data;

    return { prods, categories };
  },
);

export const favour = createSlice({
  name: 'favour',
  initialState: {
    loading: false,
    prods: [],
    activeCategory: -1,
    categories: [],
    sort: 'ratdesc',
    viewMode: 'grid',
  },

  reducers: {
    applyCategory: (state, { payload: id }) => {
      state.activeCategory = id;
      return state;
    },

    updateSort: (state, { payload: sort }) => {
      let newSort = 'ratdesc';
      if (sort === 'price') {
        newSort = state.sort === 'priceasc' ? 'pricedesc' : 'priceasc';
      }
      if (sort === 'ratdesc') {
        newSort = 'priceasc';
      }
      state.sort = newSort;
      return state;
    },

    updateViewMode: (state, { payload: newMode }) => {
      state.viewMode = newMode;
      return state;
    },
  },

  extraReducers: {
    [fetchData.pending]: (state, _) => {
      state.loading = true;
    },

    [fetchData.fulfilled]: (state, { payload }) => {
      const { prods, categories } = payload;
      state.prods = prods;
      state.loading = false;

      const all = {
        id: -1,
        name: 'Все',
        url: 'all',
      };
      state.categories = [all, ...categories];
    },

    [fetchData.rejected]: (state, { error }) => {
      state.loading = false;
      console.log('an error occured on fetch favorites data: %o', error);
    },
  },
});

export default favour.reducer;
